
import { Drawer, Input } from "element-ui"
import _ from "lodash"
import drawerHeader from "./components/drawerHeader.vue"
import couponItem from "@/components/coupons/couponItem.vue"
import couponUsageRules from "@/components/dialog/couponUsageRules.vue"
import { exchangeCoupon, checkCoupon, calcCoupon } from "@/api/coupon"
import { getCouponBillV2 } from "@/api/cart"
import { goCheckoutV2 } from "@/api/checkout"
import { trackCouponClickEvent } from "@/utils/track"
import { fen2Yuan } from "@/components/cart/js/common"

export default {
  name: "CouponSelect",
  components: {
    [Drawer.name]: Drawer,
    [Input.name]: Input,
    drawerHeader,
    couponItem,
    couponUsageRules
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    source: {
      type: String,
      default: "checkout"
    },
    // ['SJXJ1230500000067', 'SJYF1230500000002']
    sourceCouponCodes: {
      type: Array,
      default: () => []
    },
    validCoupons: {
      type: Array,
      default: () => []
    },
    invalidCoupons: {
      type: Array,
      default: () => []
    },
    ruleTitle: {
      type: String,
      default: ""
    },
    ruleContent: {
      type: String,
      default: ""
    },
    price: {
      type: Number,
      default: 0
    },
    consignId: {
      type: [String, Number],
      default: ""
    },
    calcCouponParams: {
      type: Object,
      default: () => {}
    },
    checkoutParams: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      curVisible: this.visible,
      loading: false,
      couponCode: "",
      messageShow: false,
      isApplySussess: false,
      message: "",
      tabOptions: [
        {
          label: this.$t("coupon.applicable"),
          value: "applicable",
          count: 0
        },
        {
          label: this.$t("coupon.inapplicable"),
          value: "inapplicable",
          count: 0
        }
      ],
      activeTabValue: "applicable",
      coupons: [],
      inapplicableCoupons: [],
      ruleVisible: false,
      usedAmounts: 0,
      checkedCouponAmount: 0,
      isCloseBtnClick: false
    }
  },
  computed: {
    displayCoupons() {
      return this.activeTabValue === "applicable" ? this.coupons : this.inapplicableCoupons
    },
    selectedCoupons() {
      return this.coupons.filter(item => !!item.isSelected)
    },
    selectedCouponCodes() {
      return this.selectedCoupons.map(item => item.couponCode)
    },
    isSaveDisabled() {
      if (this.sourceCouponCodes.length !== this.selectedCouponCodes.length) {
        return false
      }
      const intersectionArr = _.intersection(this.sourceCouponCodes, this.selectedCouponCodes)
      return intersectionArr.length === this.sourceCouponCodes.length
    }
  },
  watch: {
    visible(val) {
      this.curVisible = val
      this.$nextTick(() => {
        if (val) {
          this.init()
        }
      })
    }
  },
  methods: {
    fen2Yuan,
    init() {
      this.isCloseBtnClick = false
      this.isApplySussess = false
      this.couponCode = ""
      this.activeTabValue = "applicable"
      this.coupons = _.cloneDeep(this.validCoupons)
      this.inapplicableCoupons = _.cloneDeep(this.invalidCoupons)
      this.coupons.forEach(item => {
        this.$set(item, "isSelected", item.checked)
        this.$set(item, "disabled", item.canCheck != 1)
        this.$set(item, "isExpand", false)
      })

      this.inapplicableCoupons.forEach(item => {
        this.$set(item, "isSelected", false)
        this.$set(item, "disabled", true)
        this.$set(item, "isExpand", false)
      })

      this.calcCouponAmount()
      this.setTabCount()
      this.setScrollTop()
    },
    setTabCount() {
      this.tabOptions.forEach(item => {
        item.count = item.value === "applicable" ? this.coupons.length : this.inapplicableCoupons.length
      })
    },
    setScrollTop() {
      if (this.$refs.tabContent) {
        this.$refs.tabContent.scrollTop = 0
      }
    },
    async handleApply() {
      if (!this.couponCode) return
      trackCouponClickEvent(this.couponCode)
      try {
        this.loading = true
        const { data: res } = await exchangeCoupon({
          param: JSON.stringify({ promoCode: this.couponCode, addressId: this.consignId })
        })
        console.log("exchangeCoupon", res)
        if ("code" in res) {
          this.message = res.result
          this.isApplySussess = false
        } else {
          const params = _.cloneDeep(this.calcCouponParams)
          params.needHangUp = true
          delete params.couponCodeList
          delete params.tradeCouponVOs
          Object.assign(params, { couponCode: res.couponCode, consignId: this.consignId })

          const { data: checkRes } = await checkCoupon({ param: JSON.stringify(params) })
          if (checkRes.valid) {
            this.coupons.forEach(item => {
              this.$set(item, "isSelected", false)
            })
            this.$set(res, "isSelected", true)
            this.$set(res, "disabled", false)
            this.$set(res, "isExpand", false)
            this.$set(res, "storeId", checkRes.storeId)
            this.$set(res, "recommend", checkRes.recommend)
            this.coupons.unshift(res)
            await this.calcCouponAmount()
            this.setTabCount()
            this.setScrollTop()
            this.message = this.$t("coupon.applySuccessMessage")
          } else {
            const {
              data: billRes,
              code,
              result
            } = this.source === "cart"
              ? await getCouponBillV2({ param: JSON.stringify(this.checkoutParams) }, { loading: false })
              : await goCheckoutV2(
                  { param: JSON.stringify(this.calcCouponParams) },
                  { loading: false, shouldErrorHandler: true }
                )
            // 当 this.source不为购物车的时候 调用goCheckoutV2埋点
            if (this.source !== "cart") {
              if (window?.dataLayer && code !== "0000") {
                window.dataLayer.push({
                  event: "transaction_error",
                  Error_code: code,
                  Error_detail_description: result
                })
              }
            }
            this.inapplicableCoupons = (billRes.couponReponse && billRes.couponReponse.invalid) || []
            this.inapplicableCoupons.forEach(item => {
              this.$set(item, "isSelected", false)
              this.$set(item, "disabled", true)
              this.$set(item, "isExpand", false)
            })
            this.setTabCount()
            this.message = this.$t("coupon.applyInapplicableMessage")
          }
          this.isApplySussess = true
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
        this.couponCode = ""
      }

      this.setMessageShow()
    },
    setMessageShow() {
      this.messageShow = true
      setTimeout(() => {
        this.messageShow = false
      }, 5000)
    },
    toggleTab(value) {
      if (this.activeTabValue === value) return
      this.activeTabValue = value
    },
    toggleSelection(item) {
      console.log("toggleSelection", item)
      if (item.disabled) return

      item.isSelected = !item.isSelected
      this.calcCouponAmount()
    },
    async calcCouponAmount() {
      try {
        if (!this.coupons || !this.coupons.length) {
          this.usedAmounts = 0
          this.checkedCouponAmount = 0
          return
        }

        this.loading = true
        const { checkedStores = [], storeId, tradeMode } = this.calcCouponParams
        const params = {
          couponReqVOList: this.coupons.map(item => ({
            batchId: item.batchId,
            couponCode: item.couponCode,
            checked: !!item.isSelected,
            newChecked: !!item.isSelected,
            recommend: item.recommend
          })),
          tradeCouponVOs: this.coupons.map(item => ({
            couponCode: item.couponCode,
            storeId: item.storeId
          })),
          checkedStores,
          storeId,
          tradeMode
        }
        const { data: res } = await calcCoupon({ param: JSON.stringify(params) })
        this.coupons = (res.couponVO && res.couponVO.valid) || []
        this.coupons.forEach(item => {
          this.$set(item, "isSelected", item.checked)
          this.$set(item, "disabled", item.canCheck != 1)
          this.$set(item, "isExpand", false)
        })
        this.usedAmounts = (res.couponVO && res.couponVO.usedAmounts) || 0
        this.checkedCouponAmount = (res.couponVO && res.couponVO.checkedCouponAmount) || 0
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    toggleArrowDirection(item) {
      item.isExpand = !item.isExpand
    },
    onHeaderClose() {
      this.isCloseBtnClick = true
      this.$emit("close", this.isApplySussess)
    },
    handleClose() {
      if (this.isCloseBtnClick) return
      this.$emit("close", this.isApplySussess)
    },
    handleSave() {
      this.$emit("save", _.cloneDeep(this.selectedCoupons))
      this.$emit("close", false)
    },
    trackCouponClickEvent(code) {
      trackCouponClickEvent(code)
    }
  }
}
